import {
  BlockquoteBlock,
  FrameTextBlock,
  MediaBlock,
  TableBlock,
  TextBlock,
} from '@/services/Api/generated'

export type ContentItem =
  | BlockquoteBlock
  | MediaBlock
  | TableBlock
  | TextBlock
  | FrameTextBlock

export function isMediaBlock(item: ContentItem): item is MediaBlock {
  return item.type === 'media_block'
}

export function isBlockquoteBlock(item: ContentItem): item is BlockquoteBlock {
  return item.type === 'blockquote_block'
}

export function isTableBlock(item: ContentItem): item is TableBlock {
  return item.type === 'table_block'
}

export function isTextBlock(item: ContentItem): item is TextBlock {
  return item.type === 'text_block'
}

export function isFrameTextBlock(item: ContentItem): item is FrameTextBlock {
  return item.type === 'frame_text'
}
